export default (financialProductObj) => {
  const returnObj = {
    disabled: true, //是否禁用
    reason: "", //soldOut=已售罄 closed=已结束 warming=未开始，(beginner=新手，待定)
  };

  (() => {
    const { category, productType, financeProductStatus, subscribed, totalQuota, singleMin, workEndTime } = financialProductObj;

    //已售罄
    if (totalQuota >= 0 && totalQuota - subscribed < singleMin) {
      returnObj.reason = "soldOut";
    } else {
      //理财宝
      if (category === "SAVING") {
        /*
      if(productType == "RUSH")
      {
        if (financeProductStatus === "SUBSCRIBING") {
          returnObj.disabled = false;
        } else if (financeProductStatus === "WARMING") {
          returnObj.reason = "warming";
        } else {
          returnObj.reason = "closed";
        }
      }
      else
        returnObj.disabled = false;
       */

        if (/^(NONE|SUBSCRIBING)$/.test(financeProductStatus)) {
          returnObj.disabled = false;
        } else if (financeProductStatus === "WARMING") {
          returnObj.reason = "warming";
        } else {
          returnObj.reason = "closed";
        }
      }
      //质押挖矿
      else if (category === "STAKING") {
        /*
      if(productType == "LAUNCH_POOL")
      {
        if (/^(PRE_SUBSCRIBING|MINING|ONGOING)$/.test(financeProductStatus)) {
          returnObj.disabled = false;
        } else if (financeProductStatus === "WARMING") {
          returnObj.reason = "warming";
        } else {
          returnObj.reason = "closed";
        }
      }
      else
        returnObj.disabled = false;
       */
        if (productType === "LAUNCH_POOL") {
          if (/^(ONGOING)$/.test(financeProductStatus)) {
            if (workEndTime - Date.now() < 24 * 60 * 60 * 1000) {
              //距离挖矿结束剩24小时，按钮置灰
              console.log("productType LAUNCH_POOL");
              return;
            }
          }
        }

        if (/^(NONE|PRE_SUBSCRIBING|MINING|ONGOING)$/.test(financeProductStatus)) {
          returnObj.disabled = false;
        } else if (financeProductStatus === "WARMING") {
          returnObj.reason = "warming";
        } else {
          returnObj.reason = "closed";
        }
      }
      //云算力
      else if (category === "HASH_RATE") {
        if (financeProductStatus === "SUBSCRIBING") {
          returnObj.disabled = false;
        } else if (financeProductStatus === "WARMING") {
          returnObj.reason = "warming";
        } else {
          returnObj.reason = "closed";
        }
      }
    }
  })();

  return returnObj;
};
